import { useEffect } from "react";
import { useAuthStore } from "~/stores/auth.store";
import { getMe } from "~/lib/api/auth";

export function useAuthInit() {
  const { token, setAuth, clearAuth, setLoading } = useAuthStore();

  useEffect(() => {
    if (!token) {
      setLoading(false);
      return;
    }

    let cancelled = false;

    async function init() {
      try {
        const data = await getMe();
        if (!cancelled) {
          setAuth(token!, data.user, data.business);
        }
      } catch {
        if (!cancelled) {
          clearAuth();
        }
      }
    }

    init();

    return () => {
      cancelled = true;
    };
  }, [token, setAuth, clearAuth, setLoading]);
}
